import { type GuardStatus, useSettings } from '@capsicum/common';
import { useMemo } from 'react';

export const useTopUpGuardShared = (): {
	status: GuardStatus;
} => {
	const {
		areSettingsLoading,
		settings: { isTopupEnabled }
	} = useSettings();

	const getStatus = useMemo(() => {
		if (areSettingsLoading) return 'loading';
		if (!isTopupEnabled) return 'denied';

		return 'allowed';
	}, [areSettingsLoading, isTopupEnabled]);

	return {
		status: getStatus
	};
};
